/* eslint-disable */
import JSZip from 'jszip';
import { dbgprintf } from "./utils";

const MAllowedFileTypes = [ "png", "jpg", "jpeg", "svg", "gif" ];
const isIconRegex = new RegExp(`^icon.*\.(${Object.values(MAllowedFileTypes).join('|')})$`, 'gi');
const ignoreFilesRegex = /^(__|\.)/i;

/**
     * Filters out invisible and other meta-files from a zip object based on a regular expression.
     *
     * @param {Object} zip - The zip object containing files.
     * @param {Object.<string, Object>} zip.files - The files within the zip object.
     * @returns {Array} - An array of visible files that do not match the ignoreFilesRegex.
     */
export const removeIgnoredFiles = (zip) => {
    return Object.values(zip.files).filter(e => (!ignoreFilesRegex.test(e.name) && !ignoreFilesRegex.test(e.name.split('/').pop())));
};

export class ESDZippedIconPackParser {
    file = null;
    zip = null;
    constructor (options) {
        const jsZip = new JSZip();
        const zipOptions = { createFolders: true };
    }

    get name() {
        const firstEntry = zippedFiles.find(entry => entry.name);
    }

    async load(file) {
        this.file = file;
        this.zip = await jsZip.loadAsync(file, this.zipOptions);
        // this.zip.files contains all the raw files
        // strip invisible (and meta) files based on our regexFilter
        this.zippedFiles = removeIgnoredFiles(this.zip);
    }

    // get contents() {
    //     return jsZip.loadAsync(file, zipOptions).then(zip => {
    //         return zip;
    //     })
    // }
}

export function ValidateZippedIconPack(file, options = { stripInvisibles: true }) {
    if(!file) return Promise.reject(file);
    const sdIconPackFileName = file.name.replace('.streamDeckIconPack', '.sdIconPack');
    const jsZip = new JSZip();
    // const rxEndsWith = new RegExp(`(${Object.values(MAllowedFileTypes).join('|')})$`, 'gi');
    // const rxEndsWith = new RegExp(/^icon.*\.(png|jpg|jpeg|svg|gif)$/gi);

    // const isIcon = new RegExp(`^icon.*\.(${Object.values(MAllowedFileTypes).join('|')})$`, 'gi');
    // const okString = 'exists \u2714';

    const checkGifHasComplementaryPng = (icon, entries) => {
        const png = icon.name.replace(/\.gif$/i, ".png").toLowerCase();
        const found = entries.find(f => f.name.toLowerCase().endsWith(png));
        if(!found) {
            dbgprintf(`Note: ${icon.name} is missing a complementary ${png} `);
        }
        return found;
    };

    /**
     * Extracts the name of the icon pack from the given zipped files,
     * where invisible and meta-files are already removed.
     *
     * @param {Array} zippedFiles - An array of objects representing the files in the zipped icon pack.
     * @param {string} zippedFiles[].name - The name of the file within the zipped icon pack.
     * @returns {string} The name of the icon pack, or an empty string if no valid entry is found.
     */
    const getIconPackName = (zippedFiles) => {
        const firstEntry = zippedFiles.find(entry => entry.name);
        return (firstEntry && firstEntry.name) ? firstEntry.name.split('/')[ 0 ] : '';
    };

    return jsZip.loadAsync(file, { createFolders: true }).then(zip => {
        // remove invisible files or directories (or files starting with __ or . their filenames starting with __ or .)
        const zippedFiles = removeIgnoredFiles(zip);

        // console.log('+++ zippedFiles', { file, zippedFiles, files: zip.files });
        if(!zippedFiles.length) {
            return Promise.reject("No files found in zip");
        }

        const sdIconPackName = getIconPackName(zippedFiles);

        if(!sdIconPackName.length) {
            return Promise.reject("Zip entries unexpectedly missing 'name' property");
        }

        dbgprintf("Validating streamDeckIconPack %s ...", sdIconPackName);

        if(sdIconPackName !== sdIconPackFileName) {
            dbgprintf("Note: Filename mismatch: '%s' should be named '%s'", sdIconPackFileName, sdIconPackName);
        }

        dbgprintf("Found %s entries ...", zippedFiles.length);

        const files = [ 'manifest.json', 'license.txt', 'icons.json', 'icons/', 'previews/' ].map(e => {
            const result = zippedFiles.find(f => f.name == `${sdIconPackName}/${e}`);
            dbgprintf(`'${e}' %s...`, result ? 'exists' : 'missing', !result);
            return result;
        }).filter(e => e);

        const icon = zippedFiles.find(f => isIconRegex.test(f.name.split('/').pop()));
        dbgprintf(`%s  `, icon ? `'${icon.name.split('/').pop()}' exists` : 'icon missing  ', !icon);

        const filterZipFileByName = (name) => zippedFiles.filter(f => f.name.startsWith(name) && !f.dir);
        // get all icon-files, 
        // zipped files always contain their full path inside the zip in their 'name' property
        // (icons folder is excluded in filterZipFileByName already)
        const icons = filterZipFileByName(`${sdIconPackName}/icons/`); //.filter(icon => icon.name !== `${sdIconPackName}/icons/`);
        const previews = filterZipFileByName(`${sdIconPackName}/previews/`);
        const orphanedGifs = icons.filter(f => f.name && f.name.toLowerCase().endsWith('.gif') && !checkGifHasComplementaryPng(f, icons));
        
        // console.log('loadAsync:Result:', { sdIconPackName, icon, files, icons, previews, orphanedGifs });
        return { sdIconPackName, icon, files, icons, previews, orphanedGifs };
    });
}




export function ValidateZippedIconPack2(file, options = {stripInvisibles: true}) {
    if(!file) return Promise.reject(file);
    const sdIconPackFileName = file.name.replace('.streamDeckIconPack', '.sdIconPack');
    const jsZip = new JSZip();
    const zipOptions = {createFolders: true};
    // const rxEndsWith = new RegExp(`(${Object.values(MAllowedFileTypes).join('|')})$`, 'gi');
    // const rxEndsWith = new RegExp(/^icon.*\.(png|jpg|jpeg|svg|gif)$/gi);

    const isIcon = new RegExp(`^icon.*\.(${Object.values(MAllowedFileTypes).join('|')})$`, 'gi');
    // const okString = 'exists \u2714';
    const okString = 'exists1';

    const checkGifHasComplementaryPng = (icon, entries) => {
        // const png = icon.name.replace(".gif", ".png");
        const png = icon.name.replace(/\.gif$/i, ".png").toLowerCase();
        // return entries.find(f => f.name.endsWith(png));;
        const found = entries.find(f => f.name.toLowerCase().endsWith(png));
        console.log('checkGif', icon.name, found, png);
        if(!found) {
            dbgprintf(`Note: ${icon.name} is missing a complementary ${png} `);
        }
        return found;
    };

    return jsZip.loadAsync(file, zipOptions).then(zip => {
        // remove invisible files or directories (or files starting with __ or . their filenames starting with __ or .)
        // const zipKeys = Object.keys(zip.files).filter(e => (!regexFilter.test(e) && !regexFilter.test(e.split('/').pop())));
        const zipValues = Object.values(zip.files).filter(e => (!ignoreFilesRegex.test(e.name) && !ignoreFilesRegex.test(e.name.split('/').pop())));

        // console.log('+++ zipValues', {file, zipKeys, zipValues, files:zip.files});
        console.log('+++ zipValues', {file, zipValues, files:zip.files});
        if(!zipValues.length) {
            return Promise.reject("No files found in zip");
        }
        
        const firstEntry = zipValues[ 0 ];
        if(!firstEntry || !firstEntry.name) {
            return Promise.reject("Zip entries unexpectedly missing 'name' property");
        }

        const sdIconPackName = firstEntry.name.split('/')[ 0 ];

        dbgprintf("Validating streamDeckIconPack %s ...", sdIconPackName);

        if(sdIconPackName !== sdIconPackFileName) {
            dbgprintf("Note: Filename mismatch: '%s' should be named '%s'", sdIconPackFileName, sdIconPackName);
        }

        const findZipFile = (name) => zipValues.find(f => f.name === name);
        const filterZipFile = (name) => zipValues.filter(f => f.name.startsWith(name) && !f.dir);
        
        dbgprintf("Found %s entries ...", zipValues.length);

        const files = ['manifest.json', 'license.txt', 'icons.json', 'icons/', 'previews/'].map(e => {
            const result = findZipFile(`${sdIconPackName}/${e}`);
            // dbgprintf(`'${e}' %s...`, result ? 'exists' : 'missing', !result); 
            dbgprintf(`'${e}'  %s...`, result ? okString : 'missing', !result);
            return result;
        }).filter(e => e);

        const icons = [ ...filterZipFile(`${sdIconPackName}/icons/`) ];
        if(icons.length && icons[0].name == `${sdIconPackName}/icons/`) {
            icons.shift();
        }

        const previews = [...filterZipFile(`${sdIconPackName}/previews/`)];

        const arrGifs = icons.filter(f => f.name && f.name.toLowerCase().endsWith('gif'));
        // let orphanedGifs = [];
        // arrGifs.forEach(icon => {
        //     if(!checkGif(icon, icons)) {
        //         orphanedGifs.push(icon);
        //     }
        // });
        const orphanedGifs = arrGifs.filter(icon => !checkGifHasComplementaryPng(icon, icons));

        // const orphanedGifs = arrGifs.map(icon => icons.find(f => f.name.endsWith(icon.name.replace(".gif", ".png"))));

        const icon = zipValues.find(f => isIcon.test(f.name.split('/').pop()));
        dbgprintf(`%s  `, icon ? `'${icon.name.split('/').pop()}' exists` : 'icon missing  ', !icon);

        const license = findZipFile(`${sdIconPackName}/license.txt`);
        dbgprintf(`'license.txt'  %s`, license ? okString : 'missing', !license);

        return { sdIconPackName, icon, files, icons, previews, orphanedGifs };
        
        // return {sdIconPackName, icon, files, icons, previews, zipKeys, zipValues, orphanedGifs};
    });
}
